/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

/**
 * @function isKeyDown
 *
 * Check is any key is Down/Pressed
 *
 */
export function isKeyDown(event: Event): boolean {
  const {type} = event ?? {};
  return type === 'keydown';
}

/**
 * @function isTab
 *
 * Check is Tab key is Pressed
 */
export function isTab(event: KeyboardEvent): boolean {
  const {key} = event ?? {};
  return key === 'Tab';
}

/**
 * @function isShift
 *
 * Check is Shift key is Pressed
 */
export function isShift(event: KeyboardEvent): boolean {
  const {key} = event ?? {};
  return key === 'Shift';
}

/**
 * @function isEnter
 *
 * Check is Enter key is Pressed
 */
export function isEnter({key}: KeyboardEvent): boolean {
  return key === 'Enter';
}

/**
 * @function isBackspace
 *
 * Check is backspace key is Pressed
 */
export function isBackspace({key}: KeyboardEvent): boolean {
  return key === 'Backspace';
}

/**
 * @function isDownArrow
 *
 * Check is down arrow key is Pressed
 */
export function isDownArrow({key}: KeyboardEvent): boolean {
  return key === 'ArrowDown';
}

/**
 * @function isEscape
 *
 * Check is down arrow key is Pressed
 */
export function isEscape({key}: KeyboardEvent): boolean {
  return key === 'Escape';
}
